/**
 * PaymentCancelledPage - Shows when user cancels Stripe checkout
 */
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export default function PaymentCancelledPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-white flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 text-center">
          <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-gray-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h1>
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>

          <div className="bg-blue-50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-blue-800">
              Your booking request has been saved. You can complete the payment later 
              from your bookings page or retry now.
            </p>
          </div>

          <div className="space-y-3">
            {bookingId && (
              <Button 
                className="w-full bg-purple-600 hover:bg-purple-700"
                onClick={() => navigate(`/events/book/${bookingId}?retry=true`)}
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Retry Payment
              </Button>
            )}
            <Button 
              variant="outline"
              className="w-full"
              onClick={() => navigate('/events')}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Events
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
